
import CybersecurityRoadmap from "@/pages/landing/CybersecurityRoadmap";
import ThreatMonitoring from "@/pages/landing/ThreatMonitoring";
import VCISO from "@/pages/landing/VCISO";
import NCUAAssessment from "@/pages/landing/NCUAAssessment";
import PhishingSimulation from "@/pages/landing/PhishingSimulation";
import IncidentResponse from "@/pages/landing/IncidentResponse";

export const landingRoutes = [
  { path: "/cybersecurity/cybersecurity-roadmap", element: <CybersecurityRoadmap /> },
  { path: "/cybersecurity/threat-monitoring-and-detection", element: <ThreatMonitoring /> },
  { path: "/cybersecurity/vciso", element: <VCISO /> },
  { path: "/cybersecurity/ncua-assessment", element: <NCUAAssessment /> },
  { path: "/cybersecurity/phishing-simulation-and-testing", element: <PhishingSimulation /> },
  { path: "/cybersecurity/incident-response-planning", element: <IncidentResponse /> },
];
